import { render, staticRenderFns } from "./DeviceListDetail.vue?vue&type=template&id=70d88848&scoped=true"
import script from "./DeviceListDetail.vue?vue&type=script&lang=js"
export * from "./DeviceListDetail.vue?vue&type=script&lang=js"
import style0 from "./DeviceListDetail.vue?vue&type=style&index=0&id=70d88848&prod&lang=scss"
import style1 from "./DeviceListDetail.vue?vue&type=style&index=1&id=70d88848&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d88848",
  null
  
)

export default component.exports